/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import { LoaderCircle } from '@codegrade/icons';
import { Icon } from '@/components/Icon';
import { ifExpr } from '@/utils/expr';
export default tsx.component({
    name: 'loader',
    functional: true,
    props: {
        center: p(Boolean).default(true),
        pageLoader: p(Boolean).default(false),
        scale: p(Number).default(4),
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    render(h, ctx) {
        const { center, pageLoader, scale } = ctx.props;
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        const icon = (...extraClasses) => (<Icon class={extraClasses} icon={LoaderCircle} scale={scale} spin/>);
        return ifExpr(center, () => (<div class={[
                'loader center d-flex align-items-center justify-content-center',
                pageLoader ? 'page-loader flex-fill' : '',
                ctx.data.class,
                ctx.data.staticClass,
            ]} style={[ctx.data.staticStyle, ctx.data.style]}>
                    {icon()}
                </div>), () => icon('loader', ctx.data.class, ctx.data.staticClass ?? ''));
    },
});
